module.exports = __webpack_public_path__ + "static/media/preview-white.ea08bc03.svg";